const newsPath = "/News";

export const imageArray = [
	{
		heading: "EXQUISITE CELEBRATIONS ON",
		subImages: [
			{id: 1, image: `${newsPath}/EXQUISITE CELEBRATIONS ON/1.jpg`},
			{id: 2, image: `${newsPath}/EXQUISITE CELEBRATIONS ON/2.jpg`},
			{id: 3, image: `${newsPath}/EXQUISITE CELEBRATIONS ON/3.jpg`},
			{id: 4, image: `${newsPath}/EXQUISITE CELEBRATIONS ON/4.jpg`},
			{id: 5, image: `${newsPath}/EXQUISITE CELEBRATIONS ON/5.jpg`},
			{id: 6, image: `${newsPath}/EXQUISITE CELEBRATIONS ON/6.jpg`},
			{id: 7, image: `${newsPath}/EXQUISITE CELEBRATIONS ON/7.jpg`},
			{id: 8, image: `${newsPath}/EXQUISITE CELEBRATIONS ON/8.jpg`},
			{id: 9, image: `${newsPath}/EXQUISITE CELEBRATIONS ON/9.jpg`},
			{id: 10, image: `${newsPath}/EXQUISITE CELEBRATIONS ON/10.jpg`},
			{id: 11, image: `${newsPath}/EXQUISITE CELEBRATIONS ON/11.jpg`},
			{id: 12, image: `${newsPath}/EXQUISITE CELEBRATIONS ON/12.jpg`},
			{id: 13, image: `${newsPath}/EXQUISITE CELEBRATIONS ON/13.jpg`},
			{id: 14, image: `${newsPath}/EXQUISITE CELEBRATIONS ON/14.jpg`},
		],
	},
	{
		heading: "VISITED PV SINDHU",
		subImages: [],
	},
	{
		heading: "FIRST HELP FOR WOMEN",
		subImages: [
			{id: 1, image: `${newsPath}/FIRST HELP FOR WOMEN/1.jpg`},
			{id: 2, image: `${newsPath}/FIRST HELP FOR WOMEN/2.jpg`},
			{id: 3, image: `${newsPath}/FIRST HELP FOR WOMEN/3.jpg`},
		],
	},
	{
		heading: "INTERVENTIONAL RADIOLOGY STATE CONFERENCE",
		subImages: [
			{
				id: 1,
				image: `${newsPath}/INTERVENTIONAL RADIOLOGY STATE CONFERENCE/1.jpg`,
			},
			{
				id: 2,
				image: `${newsPath}/INTERVENTIONAL RADIOLOGY STATE CONFERENCE/2.jpg`,
			},
			{
				id: 3,
				image: `${newsPath}/INTERVENTIONAL RADIOLOGY STATE CONFERENCE/3.jpg`,
			},
			{
				id: 4,
				image: `${newsPath}/INTERVENTIONAL RADIOLOGY STATE CONFERENCE/4.jpg`,
			},
			{
				id: 5,
				image: `${newsPath}/INTERVENTIONAL RADIOLOGY STATE CONFERENCE/5.jpg`,
			},
			{
				id: 6,
				image: `${newsPath}/INTERVENTIONAL RADIOLOGY STATE CONFERENCE/6.jpg`,
			},
			{
				id: 7,
				image: `${newsPath}/INTERVENTIONAL RADIOLOGY STATE CONFERENCE/7.jpg`,
			},
			{
				id: 8,
				image: `${newsPath}/INTERVENTIONAL RADIOLOGY STATE CONFERENCE/8.jpg`,
			},
		],
	},
	{
		heading: "HAPPY BIRTHDAY, SHEEJA",
		subImages: [
			{id: 1, image: `${newsPath}/HAPPY BIRTHDAY, SHEEJA/1.jpg`},
			{id: 2, image: `${newsPath}/HAPPY BIRTHDAY, SHEEJA/2.jpg`},
			{id: 3, image: `${newsPath}/HAPPY BIRTHDAY, SHEEJA/3.jpg`},
			{id: 4, image: `${newsPath}/HAPPY BIRTHDAY, SHEEJA/4.jpg`},
			{id: 5, image: `${newsPath}/HAPPY BIRTHDAY, SHEEJA/5.jpg`},
			{id: 6, image: `${newsPath}/HAPPY BIRTHDAY, SHEEJA/6.jpg`},
			{id: 7, image: `${newsPath}/HAPPY BIRTHDAY, SHEEJA/7.jpg`},
			{id: 8, image: `${newsPath}/HAPPY BIRTHDAY, SHEEJA/8.jpg`},
		],
	},
	{
		heading: "PLAYING IN THE FINALS",
		subImages: [
			{id: 1, image: `${newsPath}/PLAYING IN THE FINALS/1.jpg`},
			{id: 2, image: `${newsPath}/PLAYING IN THE FINALS/2.jpg`},
			{id: 3, image: `${newsPath}/PLAYING IN THE FINALS/3.jpg`},
		],
	},
	{
		heading: "ASSOCIATION OF SURGICAL GASTROENTEROLOGISTS",
		subImages: [
			{
				id: 1,
				image: `${newsPath}/ASSOCIATION OF SURGICAL GASTROENTEROLOGISTS/1.jpg`,
			},
			{
				id: 2,
				image: `${newsPath}/ASSOCIATION OF SURGICAL GASTROENTEROLOGISTS/2.jpg`,
			},
			{
				id: 3,
				image: `${newsPath}/ASSOCIATION OF SURGICAL GASTROENTEROLOGISTS/3.jpg`,
			},
			{
				id: 4,
				image: `${newsPath}/ASSOCIATION OF SURGICAL GASTROENTEROLOGISTS/4.jpg`,
			},
			{
				id: 5,
				image: `${newsPath}/ASSOCIATION OF SURGICAL GASTROENTEROLOGISTS/5.jpg`,
			},
			{
				id: 6,
				image: `${newsPath}/ASSOCIATION OF SURGICAL GASTROENTEROLOGISTS/6.jpg`,
			},
			{
				id: 7,
				image: `${newsPath}/ASSOCIATION OF SURGICAL GASTROENTEROLOGISTS/7.jpg`,
			},
			{
				id: 8,
				image: `${newsPath}/ASSOCIATION OF SURGICAL GASTROENTEROLOGISTS/8.jpg`,
			},
		],
	},
	{
		heading: "GLIMPSES OF THE FLAG HOISTING",
		subImages: [
			{id: 1, image: `${newsPath}/GLIMPSES OF THE FLAG HOISTING/1.jpg`},
			{id: 2, image: `${newsPath}/GLIMPSES OF THE FLAG HOISTING/2.jpg`},
			{id: 3, image: `${newsPath}/GLIMPSES OF THE FLAG HOISTING/3.jpg`},
			{id: 4, image: `${newsPath}/GLIMPSES OF THE FLAG HOISTING/4.jpg`},
		],
	},
	{
		heading: "GG FAMILY CLINIC JANUARY",
		subImages: [
			{id: 1, image: `${newsPath}/GG FAMILY CLINIC JANUARY/1.jpg`},
			{id: 2, image: `${newsPath}/GG FAMILY CLINIC JANUARY/2.jpg`},
			{id: 3, image: `${newsPath}/GG FAMILY CLINIC JANUARY/3.jpg`},
			{id: 4, image: `${newsPath}/GG FAMILY CLINIC JANUARY/4.jpg`},
			{id: 5, image: `${newsPath}/GG FAMILY CLINIC JANUARY/5.jpg`},
			{id: 6, image: `${newsPath}/GG FAMILY CLINIC JANUARY/6.jpg`},
		],
	},
	{
		heading: "CELEBRATING OUR HONOURABLE VICE CHAIRMAN",
		subImages: [
			{
				id: 1,
				image: `${newsPath}/CELEBRATING OUR HONOURABLE VICE CHAIRMAN/1.jpg`,
			},
			{
				id: 2,
				image: `${newsPath}/CELEBRATING OUR HONOURABLE VICE CHAIRMAN/2.jpg`,
			},
			{
				id: 3,
				image: `${newsPath}/CELEBRATING OUR HONOURABLE VICE CHAIRMAN/3.jpg`,
			},
			{
				id: 4,
				image: `${newsPath}/CELEBRATING OUR HONOURABLE VICE CHAIRMAN/4.jpg`,
			},
		],
	},
	{
		heading: "WORLD PHARMACIST DAY",
		subImages: [
			{id: 1, image: `${newsPath}/WORLD PHARMACIST DAY/1.jpg`},
			{id: 2, image: `${newsPath}/WORLD PHARMACIST DAY/2.jpg`},
			{id: 3, image: `${newsPath}/WORLD PHARMACIST DAY/3.jpg`},
			{id: 4, image: `${newsPath}/WORLD PHARMACIST DAY/4.jpg`},
			{id: 5, image: `${newsPath}/WORLD PHARMACIST DAY/5.jpg`},
			{id: 6, image: `${newsPath}/WORLD PHARMACIST DAY/6.jpg`},
			{id: 7, image: `${newsPath}/WORLD PHARMACIST DAY/7.jpg`},
			{id: 8, image: `${newsPath}/WORLD PHARMACIST DAY/8.jpg`},
			{id: 9, image: `${newsPath}/WORLD PHARMACIST DAY/9.jpg`},
			{id: 10, image: `${newsPath}/WORLD PHARMACIST DAY/10.jpg`},
		],
	},
	{
		heading: "NATIONAL NUTRITION MONTH",
		subImages: [
			{id: 1, image: `${newsPath}/NATIONAL NUTRITION MONTH/1.jpg`},
			{id: 2, image: `${newsPath}/NATIONAL NUTRITION MONTH/2.jpg`},
			{id: 3, image: `${newsPath}/NATIONAL NUTRITION MONTH/3.jpg`},
			{id: 4, image: `${newsPath}/NATIONAL NUTRITION MONTH/4.jpg`},
			{id: 5, image: `${newsPath}/NATIONAL NUTRITION MONTH/5.jpg`},
			{id: 6, image: `${newsPath}/NATIONAL NUTRITION MONTH/6.jpg`},
			{id: 7, image: `${newsPath}/NATIONAL NUTRITION MONTH/7.jpg`},
			{id: 8, image: `${newsPath}/NATIONAL NUTRITION MONTH/8.jpg`},
			{id: 9, image: `${newsPath}/NATIONAL NUTRITION MONTH/9.jpg`},
			{id: 10, image: `${newsPath}/NATIONAL NUTRITION MONTH/10.jpg`},
			{id: 11, image: `${newsPath}/NATIONAL NUTRITION MONTH/11.jpg`},
			{id: 12, image: `${newsPath}/NATIONAL NUTRITION MONTH/12.jpg`},
			{id: 13, image: `${newsPath}/NATIONAL NUTRITION MONTH/13.jpg`},
			{id: 14, image: `${newsPath}/NATIONAL NUTRITION MONTH/14.jpg`},
			{id: 15, image: `${newsPath}/NATIONAL NUTRITION MONTH/15.jpg`},
		],
	},
	{
		heading: "WORLD HEART DAY MEDICAL CAMP",
		subImages: [
			{id: 1, image: `${newsPath}/WORLD HEART DAY MEDICAL CAMP/1.jpg`},
			{id: 2, image: `${newsPath}/WORLD HEART DAY MEDICAL CAMP/2.jpg`},
			{id: 3, image: `${newsPath}/WORLD HEART DAY MEDICAL CAMP/3.jpg`},
			{id: 4, image: `${newsPath}/WORLD HEART DAY MEDICAL CAMP/4.jpg`},
			{id: 5, image: `${newsPath}/WORLD HEART DAY MEDICAL CAMP/5.jpg`},
			{id: 6, image: `${newsPath}/WORLD HEART DAY MEDICAL CAMP/6.jpg`},
		],
	},
	{
		heading: "GG FAMILY CLINIC",
		subImages: [
			{id: 1, image: `${newsPath}/GG FAMILY CLINIC/1.jpg`},
			{id: 2, image: `${newsPath}/GG FAMILY CLINIC/2.jpg`},
			{id: 3, image: `${newsPath}/GG FAMILY CLINIC/3.jpg`},
			{id: 4, image: `${newsPath}/GG FAMILY CLINIC/4.jpg`},
			{id: 5, image: `${newsPath}/GG FAMILY CLINIC/5.jpg`},
		],
	},
	{
		heading: "CAPTURING THE MOMENTS FROM APAMT 2023",
		subImages: [
			{
				id: 1,
				image: `${newsPath}/CAPTURING THE MOMENTS FROM APAMT 2023/1.jpg`,
			},
			{
				id: 2,
				image: `${newsPath}/CAPTURING THE MOMENTS FROM APAMT 2023/2.jpg`,
			},
			{
				id: 3,
				image: `${newsPath}/CAPTURING THE MOMENTS FROM APAMT 2023/3.jpg`,
			},
			{
				id: 4,
				image: `${newsPath}/CAPTURING THE MOMENTS FROM APAMT 2023/4.jpg`,
			},
			{
				id: 5,
				image: `${newsPath}/CAPTURING THE MOMENTS FROM APAMT 2023/5.jpg`,
			},
			{
				id: 6,
				image: `${newsPath}/CAPTURING THE MOMENTS FROM APAMT 2023/6.jpg`,
			},
		],
	},
	{
		heading: "CELEBRATING STRENGTH: BREAST CANCER AWARENESS MONTH - CANERASE.2",
		subImages: [
			{
				id: 1,
				image: `${newsPath}/CELEBRATING STRENGTH: BREAST CANCER AWARENESS MONTH - CANERASE.2/1.jpg`,
			},
			{
				id: 2,
				image: `${newsPath}/CELEBRATING STRENGTH: BREAST CANCER AWARENESS MONTH - CANERASE.2/2.jpg`,
			},
			{
				id: 3,
				image: `${newsPath}/CELEBRATING STRENGTH: BREAST CANCER AWARENESS MONTH - CANERASE.2/3.jpg`,
			},
			{
				id: 4,
				image: `${newsPath}/CELEBRATING STRENGTH: BREAST CANCER AWARENESS MONTH - CANERASE.2/4.jpg`,
			},
			{
				id: 5,
				image: `${newsPath}/CELEBRATING STRENGTH: BREAST CANCER AWARENESS MONTH - CANERASE.2/5.jpg`,
			},
			{
				id: 6,
				image: `${newsPath}/CELEBRATING STRENGTH: BREAST CANCER AWARENESS MONTH - CANERASE.2/6.jpg`,
			},
		],
	},
	{
		heading: "GG FAMILY CLINIC KULATHOOR FIRST ANNIVERSARY",
		subImages: [
			{
				id: 1,
				image: `${newsPath}/GG FAMILY CLINIC KULATHOOR FIRST ANNIVERSARY/1.jpg`,
			},
			{
				id: 2,
				image: `${newsPath}/GG FAMILY CLINIC KULATHOOR FIRST ANNIVERSARY/2.jpg`,
			},
			{
				id: 3,
				image: `${newsPath}/GG FAMILY CLINIC KULATHOOR FIRST ANNIVERSARY/3.jpg`,
			},
			{
				id: 4,
				image: `${newsPath}/GG FAMILY CLINIC KULATHOOR FIRST ANNIVERSARY/4.jpg`,
			},
			{
				id: 5,
				image: `${newsPath}/GG FAMILY CLINIC KULATHOOR FIRST ANNIVERSARY/5.jpg`,
			},
		],
	},
	{
		heading: "BLOOD DONATION CAMP AT CET TRIVANDRUM",
		subImages: [
			{
				id: 1,
				image: `${newsPath}/BLOOD DONATION CAMP AT CET TRIVANDRUM/1.jpg`,
			},
			{
				id: 2,
				image: `${newsPath}/BLOOD DONATION CAMP AT CET TRIVANDRUM/2.jpg`,
			},
			{
				id: 3,
				image: `${newsPath}/BLOOD DONATION CAMP AT CET TRIVANDRUM/3.jpg`,
			},
			{
				id: 4,
				image: `${newsPath}/BLOOD DONATION CAMP AT CET TRIVANDRUM/4.jpg`,
			},
			{
				id: 5,
				image: `${newsPath}/BLOOD DONATION CAMP AT CET TRIVANDRUM/5.jpg`,
			},
			{
				id: 6,
				image: `${newsPath}/BLOOD DONATION CAMP AT CET TRIVANDRUM/6.jpg`,
			},
		],
	},
	{
		heading: "CAPTURING THE MOMENTS FROM APAMT 2023",
		subImages: [
			{
				id: 1,
				image: `${newsPath}/CAPTURING THE MOMENTS FROM APAMT 2023/1.jpg`,
			},
			{
				id: 2,
				image: `${newsPath}/CAPTURING THE MOMENTS FROM APAMT 2023/2.jpg`,
			},
			{
				id: 3,
				image: `${newsPath}/CAPTURING THE MOMENTS FROM APAMT 2023/3.jpg`,
			},
			{
				id: 4,
				image: `${newsPath}/CAPTURING THE MOMENTS FROM APAMT 2023/4.jpg`,
			},
			{
				id: 5,
				image: `${newsPath}/CAPTURING THE MOMENTS FROM APAMT 2023/5.jpg`,
			},
			{
				id: 6,
				image: `${newsPath}/CAPTURING THE MOMENTS FROM APAMT 2023/6.jpg`,
			},
		],
	},
	{
		heading: "IN-HOUSE MEDICAL CAMP FOCUSED ON ONCOLOGY AT GG HOSPITAL",
		subImages: [
			{
				id: 1,
				image: `${newsPath}/IN-HOUSE MEDICAL CAMP FOCUSED ON ONCOLOGY AT GG HOSPITAL/1.jpg`,
			},
		],
	},
	{
		heading: "MEDICAL CAMP AT CSI CHURCH KAZHAKUTTOM",
		subImages: [
			{
				id: 1,
				image: `${newsPath}/MEDICAL CAMP AT CSI CHURCH KAZHAKUTTOM/1.jpg`,
			},
		],
	},
	{
		heading: "CHILDREN'S DAY CELEBRATION",
		subImages: [
			{id: 1, image: `${newsPath}/CHILDREN'S DAY CELEBRATION/1.jpg`},
			{id: 2, image: `${newsPath}/CHILDREN'S DAY CELEBRATION/2.jpg`},
			{id: 3, image: `${newsPath}/CHILDREN'S DAY CELEBRATION/3.jpg`},
			{id: 4, image: `${newsPath}/CHILDREN'S DAY CELEBRATION/4.jpg`},
			{id: 5, image: `${newsPath}/CHILDREN'S DAY CELEBRATION/5.jpg`},
			{id: 6, image: `${newsPath}/CHILDREN'S DAY CELEBRATION/6.jpg`},
			{id: 7, image: `${newsPath}/CHILDREN'S DAY CELEBRATION/7.jpg`},
			{id: 8, image: `${newsPath}/CHILDREN'S DAY CELEBRATION/8.jpg`},
			{id: 9, image: `${newsPath}/CHILDREN'S DAY CELEBRATION/9.jpg`},
		],
	},
	{
		heading: "SPREADING JOY AND LAUGHTER AT GG FAMILY CLINIC",
		subImages: [
			{
				id: 1,
				image: `${newsPath}/SPREADING JOY AND LAUGHTER AT GG FAMILY CLINIC/1.jpg`,
			},
			{
				id: 2,
				image: `${newsPath}/SPREADING JOY AND LAUGHTER AT GG FAMILY CLINIC/2.jpg`,
			},
			{
				id: 3,
				image: `${newsPath}/SPREADING JOY AND LAUGHTER AT GG FAMILY CLINIC/3.jpg`,
			},
			{
				id: 4,
				image: `${newsPath}/SPREADING JOY AND LAUGHTER AT GG FAMILY CLINIC/4.jpg`,
			},
			{
				id: 5,
				image: `${newsPath}/SPREADING JOY AND LAUGHTER AT GG FAMILY CLINIC/5.jpg`,
			},
		],
	},
	{
		heading: "MEDICAL CAMP AT NAVAKERALA SADASS",
		subImages: [
			{
				id: 1,
				image: `${newsPath}/MEDICAL CAMP AT NAVAKERALA SADASS/1.jpg`,
			},
			{
				id: 2,
				image: `${newsPath}/MEDICAL CAMP AT NAVAKERALA SADASS/2.jpg`,
			},
			{
				id: 3,
				image: `${newsPath}/MEDICAL CAMP AT NAVAKERALA SADASS/3.jpg`,
			},
		],
	},
	{
		heading: "BLOOD DONATION CAMP AT MAHINDRA FINANCE",
		subImages: [
			{
				id: 1,
				image: `${newsPath}/BLOOD DONATION CAMP AT MAHINDRA FINANCE/1.jpg`,
			},
			{
				id: 2,
				image: `${newsPath}/BLOOD DONATION CAMP AT MAHINDRA FINANCE/2.jpg`,
			},
		],
	},
	{
		heading: "GG SCHOOL OF NURSING FIRST BATCH",
		subImages: [
			{
				id: 1,
				image: `${newsPath}/GG SCHOOL OF NURSING FIRST BATCH/1.jpg`,
			},
			{
				id: 2,
				image: `${newsPath}/GG SCHOOL OF NURSING FIRST BATCH/2.jpg`,
			},
			{
				id: 3,
				image: `${newsPath}/GG SCHOOL OF NURSING FIRST BATCH/3.jpg`,
			},
		],
	},
	{
		heading: "HARMONIZING CINEMA AND CARE",
		subImages: [
			{
				id: 1,
				image: `${newsPath}/HARMONIZING CINEMA AND CARE/1.jpg`,
			},
			{
				id: 2,
				image: `${newsPath}/HARMONIZING CINEMA AND CARE/2.jpg`,
			},
		],
	},
	{
		heading: "NAVAKERALA SADAS STRIKES AGAIN",
		subImages: [
			{
				id: 1,
				image: `${newsPath}/NAVAKERALA SADAS STRIKES AGAIN/1.jpg`,
			},
			{
				id: 2,
				image: `${newsPath}/NAVAKERALA SADAS STRIKES AGAIN/2.jpg`,
			},
			{
				id: 3,
				image: `${newsPath}/NAVAKERALA SADAS STRIKES AGAIN/3.jpg`,
			},
		],
	},
	{
		heading: "98TH NATIONAL CONFERENCE IMA HELD IN KOVALAM",
		subImages: [
			{
				id: 1,
				image: `${newsPath}/98TH NATIONAL CONFERENCE IMA HELD IN KOVALAM/1.jpg`,
			},
			{
				id: 2,
				image: `${newsPath}/98TH NATIONAL CONFERENCE IMA HELD IN KOVALAM/2.jpg`,
			},
			{
				id: 3,
				image: `${newsPath}/98TH NATIONAL CONFERENCE IMA HELD IN KOVALAM/3.jpg`,
			},
			{
				id: 4,
				image: `${newsPath}/98TH NATIONAL CONFERENCE IMA HELD IN KOVALAM/4.jpg`,
			},
			{
				id: 5,
				image: `${newsPath}/98TH NATIONAL CONFERENCE IMA HELD IN KOVALAM/5.jpg`,
			},
			{
				id: 6,
				image: `${newsPath}/98TH NATIONAL CONFERENCE IMA HELD IN KOVALAM/6.jpg`,
			},
			{
				id: 7,
				image: `${newsPath}/98TH NATIONAL CONFERENCE IMA HELD IN KOVALAM/7.jpg`,
			},
		],
	},
	{
		heading:
			"DR. SHEEJA G MANOJ WITH THE EMINENT LEADERSHIP IN HEALTHCARE AWARD",
		subImages: [
			{
				id: 1,
				image: `${newsPath}/DR. SHEEJA G MANOJ WITH THE EMINENT LEADERSHIP IN HEALTHCARE AWARD/1.jpg`,
			},
			{
				id: 2,
				image: `${newsPath}/DR. SHEEJA G MANOJ WITH THE EMINENT LEADERSHIP IN HEALTHCARE AWARD/2.jpg`,
			},
		],
	},
	{
		heading:
			"DR. SHEEJA G MANOJ MEETS THE OSCAR-WINNING MAESTRO, MR. RESUL POOKUTTY, AND HIS ESTEEMED WIFE SHADIA POOKUTTY",
		subImages: [
			{
				id: 1,
				image: `${newsPath}/DR. SHEEJA G MANOJ MEETS THE OSCAR-WINNING MAESTRO, MR. RESUL POOKUTTY, AND HIS ESTEEMED WIFE SHADIA POOKUTTY/1.jpg`,
			},
			{
				id: 2,
				image: `${newsPath}/DR. SHEEJA G MANOJ MEETS THE OSCAR-WINNING MAESTRO, MR. RESUL POOKUTTY, AND HIS ESTEEMED WIFE SHADIA POOKUTTY/2.jpg`,
			},
		],
	},
	{
		heading:
			"CAPTURING MOMENTS FROM OUR CELEBRATION OF RECEIVING INC APPROVAL FOR GG SCHOOL OF NURSING",
		subImages: [
			{
				id: 1,
				image: `${newsPath}/CAPTURING MOMENTS FROM OUR CELEBRATION OF RECEIVING INC APPROVAL FOR GG SCHOOL OF NURSING/1.jpg`,
			},
			{
				id: 2,
				image: `${newsPath}/CAPTURING MOMENTS FROM OUR CELEBRATION OF RECEIVING INC APPROVAL FOR GG SCHOOL OF NURSING/2.jpg`,
			},
		],
	},
	{
		heading:
			"CHAIRMAN GOKULAM GOPALAN RECEIVES DEEPIKA LIFETIME ACHIEVEMENT AWARD",
		subImages: [],
	},
	{
		heading: "INTERNATIONAL NURSES DAY CELEBRATION AT GG HOSPITAL",
		subImages: [
			{
				id: 1,
				image: `${newsPath}/INTERNATIONAL NURSES DAY CELEBRATION AT GG HOSPITAL/1.jpg`,
			},
			{
				id: 2,
				image: `${newsPath}/INTERNATIONAL NURSES DAY CELEBRATION AT GG HOSPITAL/2.jpg`,
			},
			{
				id: 3,
				image: `${newsPath}/INTERNATIONAL NURSES DAY CELEBRATION AT GG HOSPITAL/3.jpg`,
			},
			{
				id: 4,
				image: `${newsPath}/INTERNATIONAL NURSES DAY CELEBRATION AT GG HOSPITAL/4.jpg`,
			},
		],
	},
	{
		heading: "ACTRESS MS CHIPPY AND DR SHEEJA G MANOJ AT GG HOSPITAL",
		subImages: [],
	},
	{
		heading: `INSIGNIA, "CRITICAL CARE CONFERENCE AND WORKSHOP ON MECHANICAL VENTILATION"`,
		subImages: [
			{
				id: 1,
				image: `${newsPath}/INSIGNIA, "CRITICAL CARE CONFERENCE AND WORKSHOP ON MECHANICAL VENTILATION"/1.jpg`,
			},
			{
				id: 2,
				image: `${newsPath}/INSIGNIA, "CRITICAL CARE CONFERENCE AND WORKSHOP ON MECHANICAL VENTILATION"/2.jpg`,
			},
			{
				id: 3,
				image: `${newsPath}/INSIGNIA, "CRITICAL CARE CONFERENCE AND WORKSHOP ON MECHANICAL VENTILATION"/3.jpg`,
			},
			{
				id: 4,
				image: `${newsPath}/INSIGNIA, "CRITICAL CARE CONFERENCE AND WORKSHOP ON MECHANICAL VENTILATION"/4.jpg`,
			},
			{
				id: 5,
				image: `${newsPath}/INSIGNIA, "CRITICAL CARE CONFERENCE AND WORKSHOP ON MECHANICAL VENTILATION"/5.jpg`,
			},
			{
				id: 6,
				image: `${newsPath}/INSIGNIA, "CRITICAL CARE CONFERENCE AND WORKSHOP ON MECHANICAL VENTILATION"/6.jpg`,
			},
		],
	},
	{
		heading: "LAMP LIGHTING CEREMONY AT GG SCHOOL OF NURSING",
		subImages: [
			{
				id: 1,
				image: `${newsPath}/LAMP LIGHTING CEREMONY AT GG SCHOOL OF NURSING/1.jpg`,
			},
			{
				id: 2,
				image: `${newsPath}/LAMP LIGHTING CEREMONY AT GG SCHOOL OF NURSING/2.jpg`,
			},
		],
	},
	{
		heading:
			"WE ARE HONORED TO HAVE CPI LEADER MR. BINOY VISWAM VISIT OUR ESTEEMED MANAGING DIRECTOR, DR. SHEEJA G MANOJ",
		subImages: [],
	},
	{
		heading: "BLOOD DONATION CAMP AT KAMALESHWARAM HIGHER SECONDARY SCHOOL",
		subImages: [
			{
				id: 1,
				image: `${newsPath}/BLOOD DONATION CAMP AT KAMALESHWARAM HIGHER SECONDARY SCHOOL/1.jpg`,
			},
			{
				id: 2,
				image: `${newsPath}/BLOOD DONATION CAMP AT KAMALESHWARAM HIGHER SECONDARY SCHOOL/2.jpg`,
			},
			{
				id: 3,
				image: `${newsPath}/BLOOD DONATION CAMP AT KAMALESHWARAM HIGHER SECONDARY SCHOOL/3.jpg`,
			},
		],
	},
	{
		heading:
			"DR. ANSAR P P, OUR SURGICAL ONCOLOGIST, FOR REPRESENTING GG HOSPITAL AT THE ISO-MVR CANCON 2024",
		subImages: [
			{
				id: 1,
				image: `${newsPath}/DR. ANSAR P P, OUR SURGICAL ONCOLOGIST, FOR REPRESENTING GG HOSPITAL AT THE ISO-MVR CANCON 2024/1.jpg`,
			},
			{
				id: 2,
				image: `${newsPath}/DR. ANSAR P P, OUR SURGICAL ONCOLOGIST, FOR REPRESENTING GG HOSPITAL AT THE ISO-MVR CANCON 2024/2.jpg`,
			},
			{
				id: 3,
				image: `${newsPath}/DR. ANSAR P P, OUR SURGICAL ONCOLOGIST, FOR REPRESENTING GG HOSPITAL AT THE ISO-MVR CANCON 2024/3.jpg`,
			},
			{
				id: 4,
				image: `${newsPath}/DR. ANSAR P P, OUR SURGICAL ONCOLOGIST, FOR REPRESENTING GG HOSPITAL AT THE ISO-MVR CANCON 2024/4.jpg`,
			},
		],
	},
	{
		heading:
			"GG HOSPITAL SUCCESSFULLY CONDUCTED THE MUCH-ANTICIPATED GG CANERASE 2024",
		subImages: [
			{
				id: 1,
				image: `${newsPath}/GG HOSPITAL SUCCESSFULLY CONDUCTED THE MUCH-ANTICIPATED GG CANERASE 2024/1.jpg`,
			},
			{
				id: 2,
				image: `${newsPath}/GG HOSPITAL SUCCESSFULLY CONDUCTED THE MUCH-ANTICIPATED GG CANERASE 2024/2.jpg`,
			},
			{
				id: 3,
				image: `${newsPath}/GG HOSPITAL SUCCESSFULLY CONDUCTED THE MUCH-ANTICIPATED GG CANERASE 2024/3.jpg`,
			},
			{
				id: 4,
				image: `${newsPath}/GG HOSPITAL SUCCESSFULLY CONDUCTED THE MUCH-ANTICIPATED GG CANERASE 2024/3.jpg`,
			},
		],
	},
	{
		heading:
			"OUR ESTEEMED MANAGING DIRECTOR, DR. SHEEJA G MANOJ, MEETING MR. AYUB AL MURAD, DIRECTOR OF EMIGRATION, ROYAL FAMILY, SHARJAH, UAE",
		subImages: [
			{
				id: 1,
				image: `${newsPath}/OUR ESTEEMED MANAGING DIRECTOR, DR. SHEEJA G MANOJ, MEETING MR. AYUB AL MURAD, DIRECTOR OF EMIGRATION, ROYAL FAMILY, SHARJAH, UAE/1.jpg`,
			},
			{
				id: 2,
				image: `${newsPath}/OUR ESTEEMED MANAGING DIRECTOR, DR. SHEEJA G MANOJ, MEETING MR. AYUB AL MURAD, DIRECTOR OF EMIGRATION, ROYAL FAMILY, SHARJAH, UAE/2.jpg`,
			},
		],
	},
	{
		heading:
			"REFLECTING ON THE IMPACTFUL MOMENTS AT G-QCON 2024, HELD YESTERDAY (14TH NOV) AT GOKULAM GRAND, TRIVANDRUM!",
		subImages: [
			{
				id: 1,
				image: `${newsPath}/REFLECTING ON THE IMPACTFUL MOMENTS AT G-QCON 2024, HELD YESTERDAY (14TH NOV) AT GOKULAM GRAND, TRIVANDRUM!/1.jpg`,
			},
			{
				id: 2,
				image: `${newsPath}/REFLECTING ON THE IMPACTFUL MOMENTS AT G-QCON 2024, HELD YESTERDAY (14TH NOV) AT GOKULAM GRAND, TRIVANDRUM!/2.jpg`,
			},
			{
				id: 3,
				image: `${newsPath}/REFLECTING ON THE IMPACTFUL MOMENTS AT G-QCON 2024, HELD YESTERDAY (14TH NOV) AT GOKULAM GRAND, TRIVANDRUM!/3.jpg`,
			},
			{
				id: 4,
				image: `${newsPath}/REFLECTING ON THE IMPACTFUL MOMENTS AT G-QCON 2024, HELD YESTERDAY (14TH NOV) AT GOKULAM GRAND, TRIVANDRUM!/4.jpg`,
			},
			{
				id: 5,
				image: `${newsPath}/REFLECTING ON THE IMPACTFUL MOMENTS AT G-QCON 2024, HELD YESTERDAY (14TH NOV) AT GOKULAM GRAND, TRIVANDRUM!/5.jpg`,
			},
			{
				id: 6,
				image: `${newsPath}/REFLECTING ON THE IMPACTFUL MOMENTS AT G-QCON 2024, HELD YESTERDAY (14TH NOV) AT GOKULAM GRAND, TRIVANDRUM!/6.jpg`,
			},
		],
	},
	{
		heading:
			"GG HOSPITAL CELEBRATED NATIONAL PHARMACY WEEK WITH ACTIVITIES LIKE QUIZ AND POSTER COMPETITIONS, SHOWCASING THE BRILLIANCE OF OUR PHARMACY TEAM",
		subImages: [
			{
				id: 1,
				image: `${newsPath}/GG HOSPITAL CELEBRATED NATIONAL PHARMACY WEEK WITH ACTIVITIES LIKE QUIZ AND POSTER COMPETITIONS, SHOWCASING THE BRILLIANCE OF OUR PHARMACY TEAM/1.jpg`,
			},
			{
				id: 2,
				image: `${newsPath}/GG HOSPITAL CELEBRATED NATIONAL PHARMACY WEEK WITH ACTIVITIES LIKE QUIZ AND POSTER COMPETITIONS, SHOWCASING THE BRILLIANCE OF OUR PHARMACY TEAM/2.jpg`,
			},
			{
				id: 3,
				image: `${newsPath}/GG HOSPITAL CELEBRATED NATIONAL PHARMACY WEEK WITH ACTIVITIES LIKE QUIZ AND POSTER COMPETITIONS, SHOWCASING THE BRILLIANCE OF OUR PHARMACY TEAM/3.jpg`,
			},
			{
				id: 4,
				image: `${newsPath}/GG HOSPITAL CELEBRATED NATIONAL PHARMACY WEEK WITH ACTIVITIES LIKE QUIZ AND POSTER COMPETITIONS, SHOWCASING THE BRILLIANCE OF OUR PHARMACY TEAM/4.jpg`,
			},
			{
				id: 5,
				image: `${newsPath}/GG HOSPITAL CELEBRATED NATIONAL PHARMACY WEEK WITH ACTIVITIES LIKE QUIZ AND POSTER COMPETITIONS, SHOWCASING THE BRILLIANCE OF OUR PHARMACY TEAM/5.jpg`,
			},
		],
	},
	{
		heading:
			"GG HOSPITAL PROUDLY INTRODUCES THE THULIUM LASER MACHINE – A CUTTING-EDGE TREATMENT FOR KIDNEY STONES",
		subImages: [],
	},
	{
		heading:
			"WATER VAPOR THERAPY (REZUM) IS AVAILABLE AT GG HOSPITAL’S UROLOGY DEPARTMENT!",
		subImages: [],
	},
	{
		heading: "A PROUD MOMENT FOR GG HOSPITAL!",
		subImages: [
			{
				id: 1,
				image: `${newsPath}/A PROUD MOMENT FOR GG HOSPITAL!/1.jpg`,
			},
			{
				id: 2,
				image: `${newsPath}/A PROUD MOMENT FOR GG HOSPITAL!/2.jpg`,
			},
		],
	},
	{
		heading: "HEARTIEST CONGRATULATIONS TO OUR SURGICAL ONCOLOGIST, DR. ANSAR",
		subImages: [
			{
				id: 1,
				image: `${newsPath}/HEARTIEST CONGRATULATIONS TO OUR SURGICAL ONCOLOGIST, DR. ANSAR/1.jpg`,
			},
			{
				id: 2,
				image: `${newsPath}/HEARTIEST CONGRATULATIONS TO OUR SURGICAL ONCOLOGIST, DR. ANSAR/2.jpg`,
			},
		],
	},
	{
		heading: "GG HOSPITAL IS PROUD TO PARTNER WITH RED FM FOR IFFK 2024",
		subImages: [
			{
				id: 1,
				image: `${newsPath}/GG HOSPITAL IS PROUD TO PARTNER WITH RED FM FOR IFFK 2024/1.jpg`,
			},
		],
	},
	{
		heading:
			"THE FESTIVE SPIRIT FILLED THE AIR AS GG SCHOOL OF NURSING, TRIVANDRUM, A PROUD SISTER CONCERN OF GG HOSPITAL, CELEBRATED CHRISTMAS 2024 IN ALL ITS GLORY",
		subImages: [
			{
				id: 1,
				image: `${newsPath}/THE FESTIVE SPIRIT FILLED THE AIR AS GG SCHOOL OF NURSING, TRIVANDRUM, A PROUD SISTER CONCERN OF GG HOSPITAL, CELEBRATED CHRISTMAS 2024 IN ALL ITS GLORY/1.jpg`,
			},
			{
				id: 2,
				image: `${newsPath}/THE FESTIVE SPIRIT FILLED THE AIR AS GG SCHOOL OF NURSING, TRIVANDRUM, A PROUD SISTER CONCERN OF GG HOSPITAL, CELEBRATED CHRISTMAS 2024 IN ALL ITS GLORY/1.jpg`,
			},
			{
				id: 3,
				image: `${newsPath}/THE FESTIVE SPIRIT FILLED THE AIR AS GG SCHOOL OF NURSING, TRIVANDRUM, A PROUD SISTER CONCERN OF GG HOSPITAL, CELEBRATED CHRISTMAS 2024 IN ALL ITS GLORY/1.jpg`,
			},
			{
				id: 4,
				image: `${newsPath}/THE FESTIVE SPIRIT FILLED THE AIR AS GG SCHOOL OF NURSING, TRIVANDRUM, A PROUD SISTER CONCERN OF GG HOSPITAL, CELEBRATED CHRISTMAS 2024 IN ALL ITS GLORY/1.jpg`,
			},
			{
				id: 5,
				image: `${newsPath}/THE FESTIVE SPIRIT FILLED THE AIR AS GG SCHOOL OF NURSING, TRIVANDRUM, A PROUD SISTER CONCERN OF GG HOSPITAL, CELEBRATED CHRISTMAS 2024 IN ALL ITS GLORY/1.jpg`,
			},
			{
				id: 6,
				image: `${newsPath}/THE FESTIVE SPIRIT FILLED THE AIR AS GG SCHOOL OF NURSING, TRIVANDRUM, A PROUD SISTER CONCERN OF GG HOSPITAL, CELEBRATED CHRISTMAS 2024 IN ALL ITS GLORY/1.jpg`,
			},
		],
	},
	{
		heading: "RECOGNIZED FOR CARE, AWARDED FOR EXCELLENCE!",
		subImages: [
			{
				id: 1,
				image: `${newsPath}/RECOGNIZED FOR CARE, AWARDED FOR EXCELLENCE!/1.jpg`,
			},
			{
				id: 2,
				image: `${newsPath}/RECOGNIZED FOR CARE, AWARDED FOR EXCELLENCE!/2.jpg`,
			},
			{
				id: 3,
				image: `${newsPath}/RECOGNIZED FOR CARE, AWARDED FOR EXCELLENCE!/3.jpg`,
			},
			{
				id: 4,
				image: `${newsPath}/RECOGNIZED FOR CARE, AWARDED FOR EXCELLENCE!/4.jpg`,
			},
		],
	},
	{
		heading: "MISSION ACCOMPLISHED!",
		subImages: [
			{
				id: 1,
				image: `${newsPath}/MISSION ACCOMPLISHED!/1.jpg`,
			},
			{
				id: 2,
				image: `${newsPath}/MISSION ACCOMPLISHED!/2.jpg`,
			},
		],
	},
	{
		heading: "GG HOSPITAL PROUDLY SUPPORTS ROAD SAFETY AWARENESS WALKATHON!",
		subImages: [],
	},
	{
		heading: "CELEBRATING TOGETHERNESS AND NEW BEGINNINGS!",
		subImages: [
			{
				id: 1,
				image: `${newsPath}/CELEBRATING TOGETHERNESS AND NEW BEGINNINGS!/1.jpg`,
			},
			{
				id: 2,
				image: `${newsPath}/CELEBRATING TOGETHERNESS AND NEW BEGINNINGS!/2.jpg`,
			},
			{
				id: 3,
				image: `${newsPath}/CELEBRATING TOGETHERNESS AND NEW BEGINNINGS!/3.jpg`,
			},
		],
	},
	{
		heading:
			"GG HOSPITAL CANTEEN HAS BEEN OFFICIALLY RECOGNIZED AS AN EAT RIGHT CAMPUS BY THE MINISTRY OF HEALTH AND FAMILY WELFARE",
		subImages: [
			{
				id: 1,
				image: `${newsPath}/GG HOSPITAL CANTEEN HAS BEEN OFFICIALLY RECOGNIZED AS AN EAT RIGHT CAMPUS BY THE MINISTRY OF HEALTH AND FAMILY WELFARE/1.jpg`,
			},
			{
				id: 2,
				image: `${newsPath}/GG HOSPITAL CANTEEN HAS BEEN OFFICIALLY RECOGNIZED AS AN EAT RIGHT CAMPUS BY THE MINISTRY OF HEALTH AND FAMILY WELFARE/2.jpg`,
			},
		],
	},
	{
		heading:
			"OUR MANAGING DIRECTOR, DR. SHEEJA G MANOJ, HAS BEEN HONOURED WITH THE EXCELLENCE IN HEALTH & TOURISM AWARD AT THE KERALA KAUMUDI CONCLAVE",
		subImages: [
			{
				id: 1,
				image: `${newsPath}/OUR MANAGING DIRECTOR, DR. SHEEJA G MANOJ, HAS BEEN HONOURED WITH THE EXCELLENCE IN HEALTH & TOURISM AWARD AT THE KERALA KAUMUDI CONCLAVE/1.jpg`,
			},
			{
				id: 2,
				image: `${newsPath}/OUR MANAGING DIRECTOR, DR. SHEEJA G MANOJ, HAS BEEN HONOURED WITH THE EXCELLENCE IN HEALTH & TOURISM AWARD AT THE KERALA KAUMUDI CONCLAVE/2.jpg`,
			},
			{
				id: 3,
				image: `${newsPath}/OUR MANAGING DIRECTOR, DR. SHEEJA G MANOJ, HAS BEEN HONOURED WITH THE EXCELLENCE IN HEALTH & TOURISM AWARD AT THE KERALA KAUMUDI CONCLAVE/3.jpg`,
			},
			{
				id: 4,
				image: `${newsPath}/OUR MANAGING DIRECTOR, DR. SHEEJA G MANOJ, HAS BEEN HONOURED WITH THE EXCELLENCE IN HEALTH & TOURISM AWARD AT THE KERALA KAUMUDI CONCLAVE/4.jpg`,
			},
			{
				id: 5,
				image: `${newsPath}/OUR MANAGING DIRECTOR, DR. SHEEJA G MANOJ, HAS BEEN HONOURED WITH THE EXCELLENCE IN HEALTH & TOURISM AWARD AT THE KERALA KAUMUDI CONCLAVE/5.jpg`,
			},
		],
	},
	{
		heading: `ON WORLD HEALTH DAY, GG HOSPITAL PROUDLY CELEBRATED THE OCCASION AT OUR NEWLY REFURBISHED SEMINAR SPACE — GG LUMINA HALL: "WHERE KNOWLEDGE MEETS LIGHT."`,
		subImages: [
			{
				id: 1,
				image: `${newsPath}/ON WORLD HEALTH DAY, GG HOSPITAL PROUDLY CELEBRATED THE OCCASION AT OUR NEWLY REFURBISHED SEMINAR SPACE — GG LUMINA HALL: "WHERE KNOWLEDGE MEETS LIGHT."/1.jpg`,
			},
			{
				id: 2,
				image: `${newsPath}/ON WORLD HEALTH DAY, GG HOSPITAL PROUDLY CELEBRATED THE OCCASION AT OUR NEWLY REFURBISHED SEMINAR SPACE — GG LUMINA HALL: "WHERE KNOWLEDGE MEETS LIGHT."/2.jpg`,
			},
			{
				id: 3,
				image: `${newsPath}/ON WORLD HEALTH DAY, GG HOSPITAL PROUDLY CELEBRATED THE OCCASION AT OUR NEWLY REFURBISHED SEMINAR SPACE — GG LUMINA HALL: "WHERE KNOWLEDGE MEETS LIGHT."/3.jpg`,
			},
			{
				id: 4,
				image: `${newsPath}/ON WORLD HEALTH DAY, GG HOSPITAL PROUDLY CELEBRATED THE OCCASION AT OUR NEWLY REFURBISHED SEMINAR SPACE — GG LUMINA HALL: "WHERE KNOWLEDGE MEETS LIGHT."/4.jpg`,
			},
		],
	},
	{
		heading:
			"LAMP LIGHTING CEREMONY OF THE SECOND BATCH OF THE GG SCHOOL OF NURSING",
		subImages: [],
	},
	{
		heading: "WORLD LIVER DAY 2025",
		subImages: [
			{
				id: 1,
				image: `${newsPath}/WORLD LIVER DAY 2025/1.jpg`,
			},
			{
				id: 2,
				image: `${newsPath}/WORLD LIVER DAY 2025/2.jpg`,
			},
		],
	},
	{
		heading: "PROUD MOMENT FOR GG HOSPITAL!",
		subImages: [
			{
				id: 1,
				image: `${newsPath}/PROUD MOMENT FOR GG HOSPITAL!/1.jpg`,
			},
			{
				id: 2,
				image: `${newsPath}/PROUD MOMENT FOR GG HOSPITAL!/2.jpg`,
			},
			{
				id: 3,
				image: `${newsPath}/PROUD MOMENT FOR GG HOSPITAL!/3.jpg`,
			},
			{
				id: 4,
				image: `${newsPath}/PROUD MOMENT FOR GG HOSPITAL!/4.jpg`,
			},
		],
	},
	{
		heading:
			"CELEBRATING THE HEARTBEAT OF HEALTHCARE – NURSES DAY AT GG HOSPITAL",
		subImages: [
			{
				id: 1,
				image: `${newsPath}/CELEBRATING THE HEARTBEAT OF HEALTHCARE – NURSES DAY AT GG HOSPITAL/1.jpg`,
			},
			{
				id: 2,
				image: `${newsPath}/CELEBRATING THE HEARTBEAT OF HEALTHCARE – NURSES DAY AT GG HOSPITAL/2.jpg`,
			},
			{
				id: 3,
				image: `${newsPath}/CELEBRATING THE HEARTBEAT OF HEALTHCARE – NURSES DAY AT GG HOSPITAL/3.jpg`,
			},
			{
				id: 4,
				image: `${newsPath}/CELEBRATING THE HEARTBEAT OF HEALTHCARE – NURSES DAY AT GG HOSPITAL/4.jpg`,
			},
			{
				id: 5,
				image: `${newsPath}/CELEBRATING THE HEARTBEAT OF HEALTHCARE – NURSES DAY AT GG HOSPITAL/5.jpg`,
			},
		],
	},
	{
		heading:
			"GG HOSPITAL, IN COLLABORATION WITH KERALA POLICE, TO ORGANISE A SPECIAL MEDICAL CAMP AT VAZHUTHACAUD POLICE HEADQUARTERS",
		subImages: [
			{
				id: 1,
				image: `${newsPath}/GG HOSPITAL, IN COLLABORATION WITH KERALA POLICE, TO ORGANISE A SPECIAL MEDICAL CAMP AT VAZHUTHACAUD POLICE HEADQUARTERS/1.jpg`,
			},
			{
				id: 2,
				image: `${newsPath}/GG HOSPITAL, IN COLLABORATION WITH KERALA POLICE, TO ORGANISE A SPECIAL MEDICAL CAMP AT VAZHUTHACAUD POLICE HEADQUARTERS/2.jpg`,
			},
			{
				id: 3,
				image: `${newsPath}/GG HOSPITAL, IN COLLABORATION WITH KERALA POLICE, TO ORGANISE A SPECIAL MEDICAL CAMP AT VAZHUTHACAUD POLICE HEADQUARTERS/3.jpg`,
			},
		],
	},
	{
		heading:
			"THE HPB INDIAN CHAPTER RADIOLOGY COURSE BY GG HOSPITAL AND SREE GOKULAM MEDICAL COLLEGE WAS SUCCESSFULLY CONDUCTED AT POOVAR ISLAND RESORT",
		subImages: [
			{
				id: 1,
				image: `${newsPath}/THE HPB INDIAN CHAPTER RADIOLOGY COURSE BY GG HOSPITAL AND SREE GOKULAM MEDICAL COLLEGE WAS SUCCESSFULLY CONDUCTED AT POOVAR ISLAND RESORT/1.jpg`,
			},
			{
				id: 2,
				image: `${newsPath}/THE HPB INDIAN CHAPTER RADIOLOGY COURSE BY GG HOSPITAL AND SREE GOKULAM MEDICAL COLLEGE WAS SUCCESSFULLY CONDUCTED AT POOVAR ISLAND RESORT/2.jpg`,
			},
			{
				id: 3,
				image: `${newsPath}/THE HPB INDIAN CHAPTER RADIOLOGY COURSE BY GG HOSPITAL AND SREE GOKULAM MEDICAL COLLEGE WAS SUCCESSFULLY CONDUCTED AT POOVAR ISLAND RESORT/3.jpg`,
			},
			{
				id: 4,
				image: `${newsPath}/THE HPB INDIAN CHAPTER RADIOLOGY COURSE BY GG HOSPITAL AND SREE GOKULAM MEDICAL COLLEGE WAS SUCCESSFULLY CONDUCTED AT POOVAR ISLAND RESORT/4.jpg`,
			},
		],
	},
	{
		heading:
			"GG HOSPITAL BLOOD DONATION CAMP, IN ASSOCIATION WITH CRPF PALLIPPURAM",
		subImages: [
			{
				id: 1,
				image: `${newsPath}/GG HOSPITAL BLOOD DONATION CAMP, IN ASSOCIATION WITH CRPF PALLIPPURAM/1.jpg`,
			},
			{
				id: 2,
				image: `${newsPath}/GG HOSPITAL BLOOD DONATION CAMP, IN ASSOCIATION WITH CRPF PALLIPPURAM/2.jpg`,
			},
			{
				id: 3,
				image: `${newsPath}/GG HOSPITAL BLOOD DONATION CAMP, IN ASSOCIATION WITH CRPF PALLIPPURAM/3.jpg`,
			},
			{
				id: 4,
				image: `${newsPath}/GG HOSPITAL BLOOD DONATION CAMP, IN ASSOCIATION WITH CRPF PALLIPPURAM/4.jpg`,
			},
			{
				id: 5,
				image: `${newsPath}/GG HOSPITAL BLOOD DONATION CAMP, IN ASSOCIATION WITH CRPF PALLIPPURAM/5.jpg`,
			},
		],
	},
	{
		heading:
			"MEDICAL PARTNER AT THE GRAND YOGATHON EVENT ORGANISED BY LULU MALL",
		subImages: [
			{
				id: 1,
				image: `${newsPath}/MEDICAL PARTNER AT THE GRAND YOGATHON EVENT ORGANISED BY LULU MALL/1.jpg`,
			},
			{
				id: 2,
				image: `${newsPath}/MEDICAL PARTNER AT THE GRAND YOGATHON EVENT ORGANISED BY LULU MALL/2.jpg`,
			},
			{
				id: 3,
				image: `${newsPath}/MEDICAL PARTNER AT THE GRAND YOGATHON EVENT ORGANISED BY LULU MALL/3.jpg`,
			},
			{
				id: 4,
				image: `${newsPath}/MEDICAL PARTNER AT THE GRAND YOGATHON EVENT ORGANISED BY LULU MALL/4.jpg`,
			},
		],
	},
	{
		heading:
			"GG HOSPITAL WAS PROUD TO BE THE MEDICAL PARTNER FOR THE INTERNATIONAL OLYMPIC DAY CELEBRATIONS 2025, ORGANISED BY THE KERALA OLYMPIC ASSOCIATION",
		subImages: [
			{
				id: 1,
				image: `${newsPath}/GG HOSPITAL WAS PROUD TO BE THE MEDICAL PARTNER FOR THE INTERNATIONAL OLYMPIC DAY CELEBRATIONS 2025, ORGANISED BY THE KERALA OLYMPIC ASSOCIATION/1.jpg`,
			},
			{
				id: 2,
				image: `${newsPath}/GG HOSPITAL WAS PROUD TO BE THE MEDICAL PARTNER FOR THE INTERNATIONAL OLYMPIC DAY CELEBRATIONS 2025, ORGANISED BY THE KERALA OLYMPIC ASSOCIATION/2.jpg`,
			},
			{
				id: 3,
				image: `${newsPath}/GG HOSPITAL WAS PROUD TO BE THE MEDICAL PARTNER FOR THE INTERNATIONAL OLYMPIC DAY CELEBRATIONS 2025, ORGANISED BY THE KERALA OLYMPIC ASSOCIATION/3.jpg`,
			},
		],
	},
	{
		heading:
			"GG HOSPITAL PROUDLY HONOURED ALL OUR DOCTORS ON NATIONAL DOCTORS’ DAY",
		subImages: [
			{
				id: 1,
				image: `${newsPath}/GG HOSPITAL PROUDLY HONOURED ALL OUR DOCTORS ON NATIONAL DOCTORS’ DAY/1.jpg`,
			},
		],
	},
	{
		heading:
			"GG HOSPITAL PARTNERED WITH IMA TRIVANDRUM FOR THE DOCTOR’S DAY CELEBRATION 2025",
		subImages: [
			{
				id: 1,
				image: `${newsPath}/GG HOSPITAL PARTNERED WITH IMA TRIVANDRUM FOR THE DOCTOR’S DAY CELEBRATION 2025/1.jpg`,
			},
		],
	},
	{
		heading:
			"PROUD MOMENTS FOR GG HOSPITAL AT THE MATHRUBHUMI EVOLVE HEALTH 2025",
		subImages: [
			{
				id: 1,
				image: `${newsPath}/PROUD MOMENTS FOR GG HOSPITAL AT THE MATHRUBHUMI EVOLVE HEALTH 2025/1.jpg`,
			},
			{
				id: 2,
				image: `${newsPath}/PROUD MOMENTS FOR GG HOSPITAL AT THE MATHRUBHUMI EVOLVE HEALTH 2025/2.jpg`,
			},
			{
				id: 3,
				image: `${newsPath}/PROUD MOMENTS FOR GG HOSPITAL AT THE MATHRUBHUMI EVOLVE HEALTH 2025/3.jpg`,
			},
		],
	},
];
